import CallToActionComponent from './components/CallToActionComponent';
import CampaignsComponent from './components/CampaignsComponent';
import FooterComponent from "./components/FooterComponent";
import {useEffect} from "react";
import {t} from "i18next";

function JoinPage() {
  /**
   * Initiate a timing function to let the tab title blink.
   */
  useEffect(
    () => {
      let chg : boolean = false;
      setInterval(() => {
        if (!chg) {
          document.title = t('joinPage.title');
          chg = true;
        } else {
          document.title = t('joinPage.slogan');
          chg = false;
        }
      }, 1000);
    }
  );

  return <>
    <title>{t('joinPage.title')}</title>

    <CallToActionComponent />
    <CampaignsComponent />
    <FooterComponent />
  </>;
}

export default JoinPage;